export const getSsrMobileSubdomains = (): string[] => {
    return (
        process.env.NEXT_PUBLIC_SSR_DEFAULT_SCREEN_SIZE_MOBILE_SUBDOMAINS || ""
    )
        .split(",")
        .map(value => value.trim());
};

export const checkSsrMobileSubdomainExists = (hostName: string): boolean => {
    const SSR_DEFAULT_SCREEN_SIZE_MOBILE_SUBDOMAINS = getSsrMobileSubdomains();
    if (SSR_DEFAULT_SCREEN_SIZE_MOBILE_SUBDOMAINS.includes(hostName))
        return true;
    return false;
};
